(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      document.querySelectorAll('.contact-form__form').forEach((form) => {
        const uploadWrap = form.querySelector('[data-photo-upload]');
        if (!uploadWrap || uploadWrap.dataset.bound) return;
        uploadWrap.dataset.bound = 'true';

        const fileInput = uploadWrap.querySelector('[data-photo-input]');
        const urlField = uploadWrap.querySelector('[data-image-urls]');
        const fileList = uploadWrap.querySelector('[data-file-list]');
        const fileError = uploadWrap.querySelector('[data-file-error]');
        const cloudName = uploadWrap.dataset.cloudName;
        const uploadPreset = uploadWrap.dataset.uploadPreset;
        const maxFiles = parseInt(fileInput.dataset.maxFiles, 10) || 3;
        const maxSize = parseInt(fileInput.dataset.maxSize, 10) || 10485760;

        let selectedFiles = [];

        const showError = (msg) => {
          fileError.textContent = msg;
          fileError.hidden = !msg;
        };

        fileInput.addEventListener('change', () => {
          showError('');
          urlField.value = '';
          const all = Array.from(fileInput.files);
          const errors = [];

          if (all.length > maxFiles) {
            errors.push(`Only the first ${maxFiles} images will be included.`);
          }

          selectedFiles = all.slice(0, maxFiles).filter((file) => {
            if (!file.type.startsWith('image/')) {
              errors.push(`${file.name} is not an image and was skipped.`);
              return false;
            }
            if (file.size > maxSize) {
              errors.push(`${file.name} is over 10MB and was skipped.`);
              return false;
            }
            return true;
          });

          fileList.innerHTML = '';
          selectedFiles.forEach((file) => {
            const li = document.createElement('li');
            li.textContent = `\u2713 ${file.name}`;
            fileList.appendChild(li);
          });
          fileList.hidden = selectedFiles.length === 0;
          if (errors.length) showError(errors.join(' '));
        });

        const uploadFile = async (file) => {
          const body = new FormData();
          body.append('file', file);
          body.append('upload_preset', uploadPreset);
          const res = await fetch(
            `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
            { method: 'POST', body }
          );
          if (!res.ok) throw new Error(`Upload failed for ${file.name}`);
          const data = await res.json();
          return data.secure_url;
        };

        // Intercept at button click so we never touch the form's submit event.
        // Fabric's theme JS also has a submit listener, so any call to
        // requestSubmit() or form.submit() fires it a second time.
        // Uploading on click and then re-clicking the button keeps us out of
        // the submit event entirely.
        const submitBtn = form.querySelector('button[type="submit"], [type="submit"]');
        if (submitBtn) {
          submitBtn.addEventListener('click', async (event) => {
            // Nothing to upload, or already uploaded — pass through normally
            if (selectedFiles.length === 0 || urlField.value) return;

            // Upload already in progress — block
            if (submitBtn.dataset.uploading) {
              event.preventDefault();
              return;
            }

            event.preventDefault();
            submitBtn.dataset.uploading = 'true';
            submitBtn.disabled = true;
            const originalLabel = submitBtn.textContent;
            submitBtn.textContent = 'Uploading photos\u2026';

            try {
              const urls = await Promise.all(selectedFiles.map(uploadFile));
              urlField.value = urls.join('\n');
            } catch (err) {
              urlField.value = '(Customer attached photos but the upload failed)';
            }

            submitBtn.disabled = false;
            submitBtn.textContent = originalLabel;
            // urlField is now populated so the guard above passes through
            submitBtn.click();
          });
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
